/**
 * Remove all descendant components of container components from founded elements' collection.
 * Container components, the one with data-component-container attribute, will initialize its descendants.
 * @param elements
 */
export function filterOutContainerDescendantComponents(elements: HTMLElement[]) {
    const noFormComponentsList: HTMLElement[] = [];
    const formComponents: HTMLElement[] = [];
    for (const element of elements) {
        if (element.dataset.componentContainer !== undefined) {
            formComponents.push(...Array.from(element.querySelectorAll<HTMLElement>('.gem-module-not-initialized')));
        }

        if (!formComponents.includes(element)) {
            noFormComponentsList.push(element);
        }
    }

    return noFormComponentsList;
}
